'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _findComponent = require('@brandwatch/axiom-utils/dist/findComponent');

var _findComponent2 = _interopRequireDefault(_findComponent);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Position = require('../Position/Position');

var _Position2 = _interopRequireDefault(_Position);

var _PositionSource = require('../Position/PositionSource');

var _PositionSource2 = _interopRequireDefault(_PositionSource);

var _PositionTarget = require('../Position/PositionTarget');

var _PositionTarget2 = _interopRequireDefault(_PositionTarget);

var _DropdownSource = require('./DropdownSource');

var _DropdownTarget = require('./DropdownTarget');

var _DropdownReactContext = require('./DropdownReactContext');

var _DropdownReactContext2 = _interopRequireDefault(_DropdownReactContext);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-find-dom-node */
var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.state = { isVisible: false };
    return _this;
  }

  _createClass(Dropdown, [{
    key: 'getContext',
    value: function getContext() {
      var _this2 = this;

      return {
        closeDropdown: function closeDropdown() {
          return _this2.close();
        },
        openDropdown: function openDropdown() {
          return _this2.open();
        },
        toggleDropdown: function toggleDropdown() {
          return _this2.toggle();
        },
        dropdownRef: function dropdownRef() {
          return _this2.el;
        }
      };
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.state.isVisible) {
        return this.close();
      }
      this.open();
    }
  }, {
    key: 'open',
    value: function open() {
      var onRequestOpen = this.props.onRequestOpen;


      this.setState({ isVisible: true });

      if (onRequestOpen) onRequestOpen();
    }
  }, {
    key: 'close',
    value: function close() {
      var onRequestClose = this.props.onRequestClose;


      this.setState({ isVisible: false });

      if (onRequestClose) onRequestClose();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          offset = _props.offset,
          position = _props.position,
          withMask = _props.withMask,
          rest = _objectWithoutProperties(_props, ['children', 'offset', 'position', 'withMask']);

      var isVisible = this.state.isVisible;


      return _react2.default.createElement(
        _DropdownReactContext2.default.Provider,
        { value: this.getContext() },
        _react2.default.createElement(
          _Position2.default,
          _extends({}, rest, {
            isVisible: isVisible,
            offset: offset,
            onMaskClick: withMask ? function () {
              return _this3.close();
            } : null,
            position: position,
            ref: function ref(el) {
              return _this3.el = _reactDom2.default.findDOMNode(el);
            } }),
          _react2.default.createElement(
            _PositionTarget2.default,
            null,
            _react2.default.cloneElement((0, _findComponent2.default)(children, _DropdownTarget.DropdownTargetRef))
          ),
          _react2.default.createElement(
            _PositionSource2.default,
            null,
            (0, _findComponent2.default)(children, _DropdownSource.DropdownSourceRef)
          )
        )
      );
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.propTypes = {
  /**
   * Children inside Dropdown should contain all of and
   * only DropdownTarget and DropdownSource
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Adds control to enable or disable showing the DropdownSource
   */
  enabled: _propTypes2.default.bool,
  /** Controls the starting offset of the content */
  offset: _propTypes2.default.oneOf(['start', 'middle', 'end']),
  /**
   * Invoked when the Dropdown is closed.
   */
  onRequestClose: _propTypes2.default.func,
  /**
   * Invoked when the Dropdown is opened.
   */
  onRequestOpen: _propTypes2.default.func,
  /**
   * Controls the starting position around DropdownTarget in which the
   * DropdownSource will attempt to be placed. If that position is not available
   * due to collision, it will be placed according to the flip behaviour  until
   * a valid position is found.
   */
  position: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /** Toggle that allows the arrow of the Context component to be hidden */
  showArrow: _propTypes2.default.bool,
  /**
  * Configuration to apply a mask behind the Dropdown content while
  * open. Good for disabling interactions with other things on the page.
  */
  withMask: _propTypes2.default.bool
};
Dropdown.defaultProps = {
  enabled: true,
  position: 'bottom',
  showArrow: false
};
exports.default = Dropdown;